import { Component }         from '@angular/core';
import { NavController }     from 'ionic-angular';
import { LoadingController } from 'ionic-angular';
import { ModalController }   from 'ionic-angular';
import { ViewController }    from 'ionic-angular';
import { dmHotel }           from '../sign-in/xv-hotel';
import { EnableViewModel }   from './xv-enable';
import { MLText, mlBroker }  from '../../services/MLText';
import { AppDataBroker }     from '../../services/AppData';
import { SignInPage }        from '../sign-in/sign-in';
import { dmLoading }         from '../loading/loading';

@Component({
     selector:    'page-enable-help'
    ,templateUrl: 'enable-help.html'
})
export class EnableHelpPage {
    ml: mlBroker;

    constructor(
         public viewCtrl: ViewController
        ,public mlText:   MLText
    ) {
        this.ml = this.mlText.GetBroker(
            'HotelAreaEnable'
        );
    }

    public dismiss() {
        this.viewCtrl.dismiss();
    }
}

@Component({
     selector:    'page-enable'
    ,templateUrl: 'enable.html'
})
export class EnablePage {
    Enable:       EnableViewModel;
    NewLoading:   (pMessage: string) => dmLoading;
    ShowHelp:     () => void;
    BackToSignIn: () => void;

    constructor(
         public navCtrl:       NavController
        ,public loadingCtrl:   LoadingController
        ,public modalCtrl:     ModalController
        ,public mlText:        MLText
        ,public appDataBroker: AppDataBroker
    ) {
        let hotel       = appDataBroker.GetAppData() as dmHotel;

        this.NewLoading = (pMessage: string) => {
            let loadingWidget = loadingCtrl.create({
                 content: pMessage
            });

            let loadingAPI = new dmLoading(
                (pAction: () => void) => {
                    loadingWidget.present().then(() => { pAction(); })
                }
                ,() => {
                    if (!loadingAPI.IsDismissed) {
                        loadingWidget.dismiss();
                    }
                }
            );

            loadingWidget.onDidDismiss(() => {
                loadingAPI.IsDismissed = true;
            });

            return loadingAPI;
        };

        this.ShowHelp = () => {
            let helpModal = this.modalCtrl.create(EnableHelpPage);

            helpModal.present();
        };

        this.BackToSignIn = () => {
            this.navCtrl.setRoot(SignInPage);
        };

        this.Enable       = new EnableViewModel(
             mlText
            ,hotel
            ,this.BackToSignIn
            ,this.NewLoading
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/enable/enable.ts